import React from "react";

const ClueListPiece: React.FC = ({ ...props }) => {
  return <div className="clue-list-piece" {...props} />;
};

export default ClueListPiece;
